import { countryList } from "./country";
import { statesList } from "./state";
export function defaultKeyToCompare(entity) {
    return entity.name;
}
export const compare = (a, b, keyToCompare = defaultKeyToCompare) => {
    if (keyToCompare(a) < keyToCompare(b))
        return -1;
    if (keyToCompare(a) > keyToCompare(b))
        return 1;
    return 0;
};
// Get a list of all countries.
export const getAllCountries = () => {
    return countryList;
};
// Get a list of states belonging to a specific country.
export function getStatesOfCountry(countryCode = "") {
    if (!countryCode)
        return [];
    // get data from file or cache
    const states = statesList.filter((value) => {
        return value.countryCode === countryCode;
    });
    return states.sort(compare);
}
export const findEntryByCode = (source, code) => {
    if (code && source != null) {
        const codex = source.findIndex((c) => {
            return c.isoCode === code;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
export const getCountryByCode = (isoCode) => {
    if (!isoCode)
        return undefined;
    return findEntryByCode(countryList, isoCode);
};
export const findStateByCodeAndCountryCode = (source, code, countryCode) => {
    if (code && countryCode && source != null) {
        const codex = source.findIndex((c) => {
            return c.isoCode === code && c.countryCode === countryCode;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
export const getStateByCodeAndCountry = (stateCode, countryCode) => {
    if (!stateCode)
        return undefined;
    if (!countryCode)
        return undefined;
    return findStateByCodeAndCountryCode(statesList, stateCode, countryCode);
};
